import {compose} from '@packages/utilities/fp/utils';

import type {RawData, ExpandedFieldDef, FieldDef, QueryPath} from '../types';

export const expandQueryPath =
  (data: RawData) =>
  (queryPath: QueryPath): ExpandedFieldDef[] =>
    queryPath.map(expandFieldDef(data));

export const parseQueryPath =
  (data: RawData) =>
  (queryPath: QueryPath): ExpandedFieldDef[] =>
    queryPath.map(compose(parseFieldDef)(expandFieldDef(data)));

const expandFieldDef =
  (data: RawData) =>
  (fieldDef: FieldDef): ExpandedFieldDef =>
    typeof fieldDef === 'function' ? fieldDef(data) : fieldDef;

const parseFieldDef = (fieldDef: ExpandedFieldDef): ExpandedFieldDef => {
  const hasAlias = /^[^(]+?:/.test(fieldDef);
  return hasAlias
    ? getFieldDefWithoutAlias(fieldDef)
    : getFieldDefWithoutArguments(fieldDef);
};

const getFieldDefWithoutAlias = (
  fieldDef: ExpandedFieldDef
): ExpandedFieldDef => fieldDef.split(/\s*:/)[0] ?? '';

const getFieldDefWithoutArguments = (
  fieldDef: ExpandedFieldDef
): ExpandedFieldDef => fieldDef.split(/\(/)[0] ?? '';
